'use strict';

namespace TR {

    import IScope = angular.IScope;
    import ResourceService = Core.ResourceService;
    import TransferQuote = Core.Transfers.TransferQuote;
    import AvailableExtrasPerRoom = Core.Transfers.AvailableExtrasPerRoom;
    import SelectedTransfer = Core.Transfers.SelectedTransfer;
    import BrandedFareTypesService = ekh.BrandedFareTypesService;

    interface RouteParams extends ng.route.IRouteService {
        tripId: string;
        productId: string;
    }

    class CrossSellTransfers {
        transfersEnabled: boolean;

        private isHotelJourney: boolean;

        readonly emptyTransfer: SelectedTransfer;
        readonly noneTransfer: SelectedTransfer;
        nullTransferText: () => string;
        showNoTransferOption: boolean = true;
        showMandatoryExtrasTransfer: boolean = false;
        showInitialMessage: boolean = false;
        transfersAvailabilityBusy: boolean = true;
        transfersSelectionBusy: boolean = true;
        qtys: any = sessionStorage.getItem('priceQtys');
        trip: any = this.tripService.getTrip(this.$routeParams.tripId).then(t => {
            return t;
        });

        transfer: SelectedTransfer;
        private transfers: TransferQuote[];
        rankedResults: TransferQuote[];
        private maldivesTransfers: AvailableExtrasPerRoom;

        total: number = 0;

        showDetailsError: boolean;

        private basketId: undefined | string;
        // TODO remove code related to var isTransferMandatory it is old functionality
        isTransferMandatory: boolean;
        mandatoryExtrasEnabled: boolean = false;
        isMandatoryExtra: boolean = false;
        private mandatoryTransfer: any;
        private bookedMandatoryOptions: any;
        hotelName: string;
        isAvailableTransfer: boolean;
        private transferQuoteDescription: string;
        private hotelData: any;
        private roomsWithMandatoryTransfer: any;
        private hotelExtrasSelectedTransfer: any;
        private hotelExtrasMandatoryTransfers: any[];
        private hotelProductId: string;
        private OptionId: string;
        selectedTransfer: any;
        defaultMandatoryTransfer: boolean = false;

        constructor(
            private $q :ng.IQService,
            private $routeParams :RouteParams,
            private $scope: IScope,
            private analytics,
            private basketService,
            private basketStore,
            private hotelFromSession,
            private broker: Core.Broker,
            private customCurrencyFilter,
            private resourceService: Core.ResourceService,
            private tripService: Core.TripService,
            private mandatoryTransferService,
            private hotelRoomService,
            private brandedFareTypesService: ekh.BrandedFareTypesService) {
                this.noneTransfer = { Details: { TransferId: '-1' } };
                this.emptyTransfer = { Details: { TransferId: null } };
                this.mandatoryExtrasEnabled = TRPCONFIG.Domain.MandatoryExtrasEnabled;
                this.mandatoryTransfer = [];
                if (this.isHotelJourney) {
                    this.showInitialMessage = true;
                    this.transfersAvailabilityBusy = false;
                }
                broker.subscribe('Transfers', 'ProductHotelReceivedFromBasket', e => {
                    this.basketId = e.data.basketId;
                    this.hotelProductId = e.data.productId;
                });

                $scope.$watch('tran.hotelExtrasSelectedTransfer', (val: any) => {
                    if(val && this.hotelProductId && this.basketId) {
                        this.OptionId = this.mandatoryTransferService
                                            .generateOptionId(undefined, val.HotelExtraId, val.HotelExtraOptionId);
                        const type = 2;
                        basketStore.addOption(type, this.hotelProductId, this.OptionId, this.basketId)
                        .then(()=>{
                            const hemt = this.hotelExtrasMandatoryTransfers;
                            const hest = this.hotelExtrasSelectedTransfer;
                            const options = this._getExpiredOptions(hemt, hest);
                            basketStore.removeOptions(type, this.hotelProductId, options, this.basketId).then(() => {
                                basketService.updateBasket();
                            });
                        });
                    }
                });

                broker.subscribe('Transfers', 'transferRequestFailed', () => {
                    this.showDetailsError = true;
                    if (!this.isTransferMandatory) {
                        this.transfer = angular.copy(this.noneTransfer);
                    }
                });

                $scope.$on('$destroy', () => {
                    broker.unsubscribe('Transfers');
                });

                tripService.getTrip($routeParams.tripId).then((trip: Core.Trip.TripState) => {
                    this.basketId = trip.BasketId;
                    const tripId = trip.TripId;
                    const domain = TRPCONFIG.Domain;
                    let transferSearchId: string = _.get<string>(trip, 'TransfersRequest.AvailabilitySearchId');

                    $q.all([
                        basketStore.transfer(this.basketId, $routeParams.productId),
                        basketStore.hotel(this.basketId, $routeParams.productId),
                        basketStore.all(this.basketId, $routeParams.productId)
                    ]).then(results => {
                        this.defaultMandatoryTransfer = domain.IncludeMandatoryExtrasBookedItem &&
                        domain.IncludeMandatoryExtrasInHolidaysPrice;
                        const includedExtras = JSON.parse(sessionStorage.getItem('IncludedExtras') || '{}');
                        this.selectedTransfer = includedExtras;
                        this.isMaldives(results);
                        let transfer;
                        if (this.showMandatoryExtrasTransfer && !results[0] && results[2].h.CostBreakdown) {
                            let extra;
                            results[2].h.CostBreakdown.forEach( cb =>{
                                extra = cb.ExtraReference ? cb.ExtraReference : '';
                            });
                            const id = extra ? extra.split('|')[extra.split('|').length - 1] : '-1';
                            transfer = { Details: { TransferId: id } };
                        } else {
                            transfer = results[0] || this.noneTransfer;
                        }

                        $scope.$emit('sendTransferSelection', transfer);
                        this.transfer = angular.copy(transfer);

                        const hotel = results[1];

                        if (hotel.Details.AvailableExtrasPerRoom[0] &&
                            hotel.Details.AvailableExtrasPerRoom[0].length > 0) {
                            this.maldivesTransfers = hotel.Details.AvailableExtrasPerRoom[0][0];
                        }

                        if (this.mandatoryExtrasEnabled && hotel) {
                            this.hotelFromSession.getHotel(hotel.AvailabilitySearchId, hotel.Details.Id, tripId)
                                                .then(res => {
                                this.hotelData = angular.copy(res);
                                if (this.hotelData){
                                    this._initMandatoryTransfers(hotel, trip);
                                }
                            });
                        }

                        this.transfersEnabled = _([this.tripService.tripTypes.Holiday,
                                this.tripService.tripTypes.Hotel])
                                .includes(trip.TripType) && hotel && !hotel.isVilla;


                        const getTransfers = (transferSearchId: null | string, params) => {
                            basketService.getTransfers(transferSearchId, this.basketId, tripId, params).then((r) => {
                                if (r && r.length > 0 && this.isTransferMandatory) {
                                    this.transfer.Details.TransferId = r[0].TransferId;
                                }
                                this.setResults(r, hotel);
                            });
                        };


                        if (this.isHotelJourney) {
                            broker.subscribe('Transfers', 'flightDataUpdated', e => {
                                this.transfersAvailabilityBusy = true;
                                this.transfer = angular.copy(this.noneTransfer);
                                getTransfers(null, e && e.data);
                            });
                        }

                        if (transferSearchId || !this.isHotelJourney) {
                            getTransfers(transferSearchId, {});
                        }

                        if (hotel && trip.FlightsRequest && trip.FlightsRequest.Destination) {
                            this._checkIstransferMandatory(trip.FlightsRequest);
                        }

                        this._setTransfersWatcher(trip, tripId, transferSearchId);

                    }).then(angular.noop, basketService.restartHolidayWorkflow);
                }, basketService.bookingAlreadyDone);

            }

        _getExpiredOptions(transfers, currentTransfer) {
            let expiredOptionsIds = Array();
            if(currentTransfer && transfers.length && transfers.length > 0) {
                let expiredTransfers = transfers.filter(t => {
                    return t.HotelExtraId === currentTransfer.HotelExtraId
                        && t.HotelExtraOptionId !== currentTransfer.HotelExtraOptionId;
                });
                expiredTransfers.forEach(et => {
                    let OptionId = this.mandatoryTransferService
                                      .generateOptionId(undefined, et.HotelExtraId, et.HotelExtraOptionId);
                    expiredOptionsIds.push({OptionId});
                });
            }
            return expiredOptionsIds;
        }

        private transferQuoteDescriptionWithPrice: string;

        // This function checks for whether a destination requires a transfer.
        // e.g. the Maldives is required to select a transfer so the 'no transfer' option is hidden.
        isMaldives(results) {
            const MandatroyTransferAirportCodes = TRPCONFIG.Domain2.MandatoryTransferAirportCodes;
            const MandatoryTransferEnabled = TRPCONFIG.Domain2.MandatoryTransferEnabled;
            const flight = results[2].f;
            let airportCodes : string[] = [];
            const itinerary = flight.Details.Itinerary;
            const legs = itinerary.Legs;

            legs.map(leg => {
                airportCodes.push(leg.ArrivalAirport.Code);
            });

            const OutboundAirportCode = airportCodes[0];
            let showNoTransferOption = this.showNoTransferOption;

            MandatroyTransferAirportCodes.map(code => {
                if (code === OutboundAirportCode) {
                    showNoTransferOption = false;
                }
            });

            MandatoryTransferEnabled.map(code => {
                if (code === OutboundAirportCode) {
                    this.showMandatoryExtrasTransfer = true;
                }
            });

            this.showNoTransferOption = showNoTransferOption;
        }

        setResults(r, hotel) {

            if (this.showMandatoryExtrasTransfer && hotel.Details.AvailableExtrasPerRoom[0] &&
                hotel.Details.AvailableExtrasPerRoom[0].length > 0) {
                    let CombinedRoomsCost = {};
                    let extras = hotel.Details.AvailableExtrasPerRoom;
                    this.transfers = <TransferQuote[]>_.sortBy(
                        hotel.Details.AvailableExtrasPerRoom[0][0].Options, 'GrossCost');
                    if (extras.length > 1) {
                        for (let j = 0; j < this.transfers.length; j++) {
                            for (let i = 0; i < extras.length; i++) {
                                if (CombinedRoomsCost[extras[i][0].Options[j].HotelExtraOptionId]) {
                                    let cost = CombinedRoomsCost[extras[i][0].Options[j].HotelExtraOptionId];
                                    CombinedRoomsCost[extras[i][0].Options[j].HotelExtraOptionId] =
                                        cost + extras[i][0].Options[j].GrossCost;
                                } else {
                                    CombinedRoomsCost[extras[i][0].Options[j].HotelExtraOptionId] =
                                        extras[i][0].Options[j].GrossCost;
                                }
                            }
                        }
                        extras[0][0].Options.forEach(
                            option => {
                                option.GrossCost = CombinedRoomsCost[option.HotelExtraOptionId];
                            }
                        );
                        this.transfers = <TransferQuote[]>_.sortBy(
                            extras[0][0].Options, 'GrossCost');
                    }
            } else {
                if (r != null) {
                    this.transfers = <TransferQuote[]>_.sortBy(r, 'TotalPrice');
                    this._updateSubtitle();
                    //so that we can test both versions of the page
                    // we need to create a secondary limited list of transfers to use on the new design
                    this.rankedResults = <TransferQuote[]>_.sortBy(_.take(r, 3), 'TotalPrice');
                    this.isAvailableTransfer = (this.rankedResults && this.rankedResults.length > 0) ||
                                                this.showInitialMessage;
                }
            }

            if (hotel != null) {
                const hotelDetails = _.get(hotel, 'Details');
                const bookedItems = _.get(hotelDetails, 'BookedItems');
                const mandatoryTransfers = _.get(bookedItems[0], 'mandatoryTransfers');

                if (mandatoryTransfers) {
                    this.isAvailableTransfer = true;
                }
            }

            if (TRPCONFIG.Domain.EnforceTransferOptionSelection && this.isNoneTransfer(this.transfer)) {
                this.transfer = angular.copy(this.emptyTransfer);
            }

            this.transfersAvailabilityBusy = false;

            //tracking
            if (r != null && r.length > 0) {
                this._trackingTransferSelection(this.transfer.Details.TransferId);
            } else {
                this.analytics.track('mixpanel', 'OptionsTransferNoAvailability');
            }

        }

        isNoneTransfer(transfer :SelectedTransfer) :boolean {
            return angular.equals(transfer, this.noneTransfer);
        }

        _setMandatoryTransferWatcher(trip, hotel) {
            if (this.tripService.supportsTransfers(trip)) {
                this.$scope.$watchCollection('tran.mandatoryTransfer', () => {
                    const transfersWrapper = {transfers: this.mandatoryTransfer};
                    const options = this.mandatoryTransferService
                    .generateOptionsForMultiRooms(transfersWrapper,
                        this.roomsWithMandatoryTransfer);
                    this._changeMandatoryTransfer(options, hotel);
                });
            }
        }

        _setTransfersWatcher(trip, tripId, transferSearchId) {
            if (this.tripService.supportsTransfers(trip)) {
                this.$scope.$watch('tran.transfer.Details.TransferId', (val) => {
                    let isObject = typeof val === 'object' && val !== null;

                    if (TRPCONFIG.Domain.EnforceTransferOptionSelection) {
                        if (this.transfers && this.transfers.length > 0) {
                            this.$scope.$emit('sendTransferSelection', val);
                            let transferSelected: any = val;
                            let transferType;
                            if(transferSelected){
                                if(isObject) {
                                    transferType = this.transfers.filter(
                                        trans => trans.TransferId.TransferCode === transferSelected.TransferCode
                                    );
                                } else {
                                    if (val === -1) {
                                        transferType = this.transfers.filter(
                                            trans => trans.TransferId.TransferCode === transferSelected.TransferCode
                                        );
                                    } else if (val !== -1) {
                                        transferType = this.transfers.filter(
                                            trans => trans.HotelExtraOptionId === transferSelected
                                        );
                                    }
                                }
                            } else {
                                transferType = [];
                            }
                            this.selectedTransfer.ExtraOptionId = transferType.length > 0 &&
                            transferType[0].HotelExtraOptionId ? transferType[0].HotelExtraOptionId : null;
                            this.selectedTransfer.ClientPrice = transferType.length > 0 &&
                            transferType[0].GrossCost ? transferType[0].GrossCost : null;
                            sessionStorage.setItem('Transfer', JSON.stringify(
                            transferType[0] ? transferType[0] : null
                            ));
                        }
                        else {
                            this.$scope.$emit('sendTransferSelection', this.noneTransfer);
                        }
                    }

                    if (val == null) {
                        return;
                    }
                    this.$scope.$emit('flash:hide');
                    this.transfersSelectionBusy = true;
                    if (this.transfers && this.transfers.length > 0) {
                        this._trackingTransferSelection(val);
                    }
                    this._updateSubtitle();

                    if (val !== this.noneTransfer.Details.TransferId) {
                        //we need to re-check the trip here in case we have just generated the search id
                        this.tripService.getTrip(tripId).then((t) => {
                            transferSearchId = _.get<string>(t, 'TransfersRequest.AvailabilitySearchId');
                            if (this.showMandatoryExtrasTransfer && this.maldivesTransfers &&
                                this.maldivesTransfers.Options){
                                //Expected in this format:  HotelExtra|<RoomIndex>|<ExtraId>|<OptionId>
                                val = `HotelExtra|0|${this.maldivesTransfers.HotelExtraId}|${val}`;
                            }
                            this.basketService.selectTransfer(val, transferSearchId, this.basketId, tripId)
                                .then(async () => {
                                    this.basketService.updateBasket();
                                    this.showDetailsError = false;
                                    this.transfersSelectionBusy = false;
                                    if (sessionStorage.getItem('storeSelectedFlight') !== null ||
                                    sessionStorage.getItem('DefaultFlight') !== null  && isObject) {
                                        TRPCONFIG.Domain.BrandedFareCancellations =
                                            await this.brandedFareTypesService
                                            .getCancellationCharges(this.basketId);
                                        sessionStorage.setItem('BrandedFareCancellations',
                                            JSON.stringify(TRPCONFIG.Domain.BrandedFareCancellations));
                                    }
                                });
                        });
                    } else {
                        this.basketStore.removeTransfer(this.basketId).then(this.basketService.updateBasket)
                            .then(async () => {
                                if (sessionStorage.getItem('storeSelectedFlight') !== null ||
                                sessionStorage.getItem('DefaultFlight') !== null  && isObject) {
                                    TRPCONFIG.Domain.BrandedFareCancellations =
                                        await this.brandedFareTypesService
                                        .getCancellationCharges(this.basketId);
                                    sessionStorage.setItem('BrandedFareCancellations',
                                        JSON.stringify(TRPCONFIG.Domain.BrandedFareCancellations));
                                }
                            });
                        this.transfersSelectionBusy = false;
                    }
                });

                this.nullTransferText = this.resourceService.getDeferred('NOTRANSFERREQUIRED');
            }
        }

        async _trackingTransferSelection(transferId) {
            let min,max;
            if (this.showMandatoryExtrasTransfer && this.transfers && this.transfers.length > 0 &&
                this.transfers[0].GrossCost) {
                min = _.first(this.transfers).GrossCost;
                max = _.last(this.transfers).GrossCost;
            } else {
                min = _.first(this.transfers).TotalPrice;
                max = _.last(this.transfers).TotalPrice;
            }
            const data: any = {
                Title: null,
                CostPP: null,
                CostTotal: null,
                OptionIndex: null,
                TotalOptions: this.transfers.length + 1, //+1 for 'no transfer' options
                MinOptionCostTotal: min,
                MaxOptionCostTotal: max,
                HotelAndFlightCost: null,
                SupplierName: null
            };

            TRPCONFIG.Domain.TransferPrice = 0;

            if (transferId == null) {
                data.Title = 'Nothing selected';
                TRPCONFIG.Domain.TransferPrice = 0;
            } else if (transferId !== '-1') {
                let index = 0;
                const quote = _.find(this.transfers, (t, i) => {
                    index = i;
                    return angular.equals(t.TransferId, transferId);
                });

                if (quote && quote.Type) {
                    data.Title = quote.Type;
                    data.CostPP = quote.PerPersonPrice;
                    data.CostTotal = quote.TotalPrice;
                    data.OptionIndex = index + 1; //0-based index will confuse end user
                    data.SupplierName = quote.SupplierName;
                    let transferPrice = data.CostTotal;
                    TRPCONFIG.Domain.TransferPrice = transferPrice;
                }

            } else if (transferId === '-1') {
                data.Title = 'No Transfer';
                TRPCONFIG.Domain.TransferPrice = 0;
            }


            this.$q.all([
                this.basketStore.hotelCost(this.basketId),
                this.basketStore.flightCost(this.basketId)
            ]).then(res => {
                data.HotelAndFlightCost += res[0] + res[1];
                this.analytics.track('mixpanel', 'OptionsTransferSelected', data);
            });

            let trip = await this.trip;

            let selectedFlight = JSON.parse(sessionStorage.getItem('storeSelectedFlight') || '{}');
            let flightFare = JSON.parse(sessionStorage.getItem('flightFare') ||' {}');
            let fare = TRPCONFIG.Domain.FlightFare || flightFare;
            let legs = fare.Legs || selectedFlight.Legs;
            let hotel = JSON.parse(sessionStorage.getItem('hotelData') || '{}');

            let baseCost = Number(sessionStorage.getItem('baseCost')) || this.basketStore.baseCostTotal();
            let qtys = JSON.parse(this.qtys);

            let totalFares = this.brandedFareTypesService.calculateTotalFares(fare, qtys);
            let totalTaxes = this.brandedFareTypesService.calculateTotalTaxes(fare, qtys);
            const cityTax = hotel && hotel.IsCityTaxIncludedInPrice && hotel.Citytax ? hotel.Citytax : 0;

            let packageCost = baseCost + totalFares + TRPCONFIG.Domain.TransferPrice - cityTax;

            if (packageCost) {
                let accruedMiles =
                    await this.brandedFareTypesService.payloadEntry(null, trip, legs, hotel, packageCost);
                TRPCONFIG.Domain.SkywardsInfo = accruedMiles;
            }
        }

        _updateSubtitle() {
            if (this.transfers && this.transfer.Details.TransferId) {
                const transferQuote = _.find(this.transfers, (t) => {
                    return angular.equals(t.TransferId, this.transfer.Details.TransferId);
                });
                this.total = transferQuote ? transferQuote.TotalPrice : 0;
                this.transferQuoteDescription = transferQuote
                    ? `${transferQuote.Quantity} x ${transferQuote.Type}`
                    : '';
                this.transferQuoteDescriptionWithPrice = transferQuote
                    ? `${this.transferQuoteDescription} (${this.customCurrencyFilter(this.total)})`
                    : '';
            }
        }

        _checkIstransferMandatory(flight) {
            const destinationAiports = flight.DestinationAirports ? flight.DestinationAirports
                                       : flight.Destination.DestinationAirports.split(',');
            this.isTransferMandatory = destinationAiports.includes(...TRPCONFIG.Domain.IsTransferMandatory);
        }

        _initMandatoryTransfers(hotel, trip) {
            this.roomsWithMandatoryTransfer = this.mandatoryTransferService
            .getHolidayRoomsWithTransfers(hotel.Details) || [];
            this.roomsWithMandatoryTransfer.length > 0 ? this.transfersSelectionBusy = false : null;
            this.bookedMandatoryOptions = [];
            for(let i = 0; i < this.roomsWithMandatoryTransfer.length; i++) {
                this.bookedMandatoryOptions = this.mandatoryTransferService
                .getSelectedTransfers(hotel, this.roomsWithMandatoryTransfer);
                this.mandatoryTransfer[i] = this.bookedMandatoryOptions[i]
                || this.roomsWithMandatoryTransfer[i].mandatoryTransfers[0];
            }
            if (this.mandatoryTransfer.length > 0 || this.roomsWithMandatoryTransfer.length > 0)  {
                this.isAvailableTransfer = true;
            }
            if (this.bookedMandatoryOptions && this.bookedMandatoryOptions.length > 0) {
                this.bookedMandatoryOptions = this.mandatoryTransferService
                                                .generateOptionsForMultiRooms({transfers: this.bookedMandatoryOptions},
                                                    this.roomsWithMandatoryTransfer);
            }
        }
        _changeMandatoryTransfer(options, hotel) {
            if (options.length > 0 && JSON.stringify(this.bookedMandatoryOptions) !== JSON.stringify(options)) {
                const productType = this.basketStore.productType.Transfer;
                const productId = hotel.ProductId;
                this.basketStore.removeOptions(productType, productId, this.bookedMandatoryOptions, this.basketId)
                    .then(() => {
                        this.bookedMandatoryOptions = options;
                        this.basketStore.addOptions(productType, productId, options, this.basketId)
                            .then(() => this.basketService.updateBasket());
                });
            }
        }
    }

    angular
        .module('TR')
        .component('crossSellTransfers', {
            bindings: {
                isHotelJourney: '<',
                isTransferMandatory: '=?',
                isAvailableTransfer: '=?',
                isMandatoryExtra: '@'
            },
            controller: CrossSellTransfers,
            controllerAs: 'tran',
            templateUrl: 'partials/home/directivetemplate?type=CrossSellTransfers'
        });
}
